import { SortOrder } from "../sort-order";

export class AssetFilters {
  alias: string;
  description: string;
  representationNames: string[];
  tenantUuids: string[];
  organizationUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
